export default __webpack_public_path__ + "static/media/earings.059f5221.png";